import '../../styles/styles.css';

import { useEffect, useRef, useState } from 'react';
import Link from 'next/link';

import Layout from '../../components/Layout';

import AnimateIn from '../../components/AnimateIn';
import VimeoVideo from '../../components/VimeoVideo';
import Image from '../../components/Image';
import ColumnLists from '../../components/ColumnLists';
import LinkButton from '../../components/LinkButton';
import LinkList from '../../components/LinkList';
import Quote from '../../components/Quote';
import WorkHeader from '../../components/WorkHeader';

import { getProject } from '../../config/general';
import hardcodedStaticProps from '../../lib/harcodedStaticProps';

const Rottefella = ({featuredProjectsList}) => {
  const project = getProject('rottefella');

  return (
    <Layout metaData={{ data: project }} featuredProjectsList={featuredProjectsList}>
      <article className="components page">
        <header className="g-row mb-100 component component--visible">
          <p className="mb-200">
            Launching a new product line for the company that defined cross
            country skiing.
          </p>
          <h1 className="t-mega project-title">Rottefella</h1>
          <p className="c-purple">
            Workout Apparel <span className="u-dot-del">·</span>{' '}
            <span className="f-italic">
              Campaign <span className="u-dot-del">·</span> Content
            </span>
          </p>
        </header>

        <VimeoVideo
          component={{
            posterVideo: '241170039',
            calculateRatio: 'auto'
          }}
        />

        <AnimateIn className="text g-row">
          <p>
            Rottefella is a skiing and activewear brand of Norwegian heritage.
            For nearly a century, they have used their deep knowledge of the
            outdoors to develop technology for active gear.
          </p>
          <p>
            Our challenge was to showcase the many technical features of their
            new apparel collection while staying true to their outdoors legacy.
          </p>
        </AnimateIn>

        <Image
          className="g-row component--no-margin"
          component={{
            image: '//images.yourmajesty.co/20171112214732/1.jpg'
          }}
        />

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20171103143643/2.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <p>
            We developed a straightforward, scrolling narrative, mixing outdoor
            imagery and product photography. This highlights the many features
            such as wicking, support, and possible combinations between the
            different garments.
          </p>
        </AnimateIn>

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20171103143648/3.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <p>
            Garments are divided into sections, and in each the user is invited
            to dive deeper to explore a range of features, from garment
            properties to fine details in the designs.
          </p>
        </AnimateIn>

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20171103143651/4.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="content-creation">Content creation</h2>
          <p>
            The endless combination of garments and features demanded a
            thoroughly planned and well-executed shoot for both digital and
            print collateral. This resulted in a large library of imagery,
            ranging from full-body shots to textile and feature closeups.
          </p>
        </AnimateIn>

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20171103152059/5.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="outcomes">Outcomes</h2>
          <p>
            A new and exciting way to browse Rottefella’s new product line. An
            experience that works just as well on your phone or laptop, as with
            in-store fixtures.
          </p>
          <p>
            Resulting in a 200% traffic increase to online store and introducing
            Rottefella’s active wear line to a international audience.
          </p>
          <p>The project is nominated for Awwwards 'Site of The Year 2017'.</p>
        </AnimateIn>

        <ColumnLists
          className="g-row"
          component={{
            title: 'Services',
            columns: [
              {
                title: 'Strategy',
                items: [
                  'Brand Strategy',
                  'Collaborative Working Sessions',
                  'Content Strategy',
                  'Creative Strategy',
                  'Product Strategy',
                  'Prototyping & Validation',
                  'Research',
                  'Technical Strategy',
                  'UX Strategy',
                  'Workshop & Facilitation'
                ]
              },

              {
                title: 'Design',
                items: [
                  'Art Direction',
                  'Creative Direction',
                  'UI/UX Design',
                  'Visual Design'
                ]
              },

              {
                title: 'Technology',
                items: [
                  'Front-end Development',
                  'Functional Prototyping',
                  'Localization',
                  'Systems Architecture',
                  'WebGL'
                ]
              },

              {
                title: 'Delivery',
                items: ['Launch', 'Monitoring', 'Quality Assurance']
              },

              {
                title: 'Content',
                items: ['Animation', 'Photography', 'Post Production']
              }
            ]
          }}
        />

        <LinkButton
          className="g-row"
          component={{
            url: 'https://klaer.rottefella.no',
            title: 'Visit website'
          }}
        />
      </article>
    </Layout>
  );
};

export { hardcodedStaticProps as getStaticProps };

export default Rottefella;
